export const SettingsDisabledOverlay = ({
  children,
  isDisabled,
}: {
  children: React.ReactNode;
  isDisabled: boolean;
}) => {
  return (
    <div style={{ position: "relative" }}>
      {isDisabled && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            cursor: "not-allowed",
          }}
          aria-hidden="true"
        />
      )}
      <div
        style={{
          opacity: isDisabled ? 0.5 : 1,
        }}
        aria-disabled={isDisabled}
      >
        {children}
      </div>
    </div>
  );
};
